module.exports = "query urlRewrite($requestPath: String!){ urlRewrite(requestPath: $requestPath) { target_path } }"